import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "./index.css";
import OurTeamImage from "../../assets/Teams.webp";
import { TeamsData } from "../../assets/media";
import DownArrow from "../../assets/arrowDown.png";
import nextArrow from "../../assets/nextArrow.png";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const TeamCarousel = ({ isMobile, isTablet }) => {
  const navigate = useNavigate();
  const [category, setCategory] = useState("Leadership Teams");
  const [activeIndex, setActiveIndex] = useState(0);

  const data = TeamsData;
  const currentTeam = data[category];

  const settings = {
    dots: false,
    infinite: true,
    centerMode: true,
    centerPadding: "0",
    slidesToShow: 3,
    focusOnSelect: true,
    nextArrow: <img src={nextArrow} alt="next" />,
    prevArrow: <></>,
    afterChange: (current) => {
      setActiveIndex(current);
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          centerMode: true,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          centerMode: true,
          arrows: true,
        },
      },
      {
        breakpoint: 560,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          arrows: true,
        },
      },
    ],
  };

  const getIndex = () => activeIndex % currentTeam.length;

  return (
    <>
      <div className="img-container">
        <img className="about-image1" src={OurTeamImage} alt="Teams" />
        <div class="text-overlay">Our Teams</div>
      </div>
      <p className="team-text">
        We are headed by an experienced team of professionals with a combined
        industry experience of more than <b>100 </b> years. Their deep
        understanding of the Indian financial sector as well as creating,
        turning around, and growing businesses, in particular, is a key driver
        of the value creation process.
      </p>
      <div className="team-carousel-tm">
        <div className="category-buttons">
          <button
            className={category === "Leadership Teams" ? "active" : ""}
            onClick={() => {
              setActiveIndex(0);
              setCategory("Leadership Teams");
            }}
          >
            Leadership Teams
          </button>
          <button
            className={category === "Investment Teams" ? "active" : ""}
            onClick={() => {
              setActiveIndex(0);
              setCategory("Investment Teams");
            }}
          >
            Investment Teams
          </button>
        </div>

        <Slider key={category} {...settings}>
          {currentTeam.map((member, index) => (
            <div
              key={index}
              role="button"
              tabIndex={0}
              className="carousel-item-team"
              onClick={() =>
                navigate(
                  `/teams/member?category=${encodeURIComponent(category)}&index=${index}`
                )
              }
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  navigate(
                    `/teams/member?category=${encodeURIComponent(category)}&index=${index}`
                  );
                }
              }}
            >
              <img src={member.image} alt={member.name} />
              <h2>{member?.name}</h2>
               <p>
            <strong>{member?.role}</strong>
          </p>
            </div>
          ))}
        </Slider>
        <div className="team-details">
          {/* <img src={DownArrow} alt="down-arrow" className="down-arrow" /> */}
         
          {/* <p>{currentTeam[getIndex() % currentTeam.length].description}</p> */}
        </div>
      </div>
    </>
  );
};

export default TeamCarousel;
